import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { useAuth } from "../../contexts/AuthContext";

export function LogoutPage() {
    const { logout } = useAuth();
    const navigate = useNavigate();

    // Use effect to handle successful login
    useEffect(() => {
        const performLogout = async () => {
            await logout();
            // Absolute path — 'www.pokerledger.club' was a relative route that
            // never reached /login.
            navigate('/login', { replace: true });
        }

        performLogout();
    }, [logout, navigate]);
    return (
        <div style={{ color: "var(--on-navy-mid)", fontFamily: "var(--f-mono)", letterSpacing: "0.12em", textTransform: "uppercase", fontSize: 12, padding: "48px 0", textAlign: "center" }}>
            Logging out…
        </div>
    );
}
